import ChartNivSchematic from "../../../../src/client/niv_acuteboekje/interactions/chart_schematic/ChartNivSchematic";
import * as React from 'react';
export default {
  ChartNivSchematic,
  React
};